<template>
  <div class="poster-container">
    <canvas ref="canvasRef" style="display: none;"></canvas>
    <img v-if="posterUrl" :src="posterUrl" class="poster-img" />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'

const props = defineProps({
  width: { type: Number, default: 428 },
  height: { type: Number, default: 760 },
  bgImage: String,
  title: String,
  subtitle: String,
  descList: { type: Array, default: () => [] },
  avatar: String,
  nickname: String,
  qrCode: String
})

const canvasRef = ref(null)
const posterUrl = ref('')

// 图片加载
const loadImg = (src) =>
  new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = src
    img.onload = () => resolve(img)
  })

// 自动换行
function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
  let line = ''
  for (let i = 0; i < text.length; i++) {
    const testLine = line + text[i]
    if (ctx.measureText(testLine).width > maxWidth && i > 0) {
      ctx.fillText(line, x, y)
      line = text[i]
      y += lineHeight
    } else {
      line = testLine
    }
  }
  ctx.fillText(line, x, y)
}

// 主绘制
async function drawPoster() {
  console.log(1918)
  const canvas = canvasRef.value
  const ctx = canvas.getContext('2d')

  const dpr = 2
  canvas.width = props.width * dpr
  canvas.height = props.height * dpr
  ctx.scale(dpr, dpr)

  const [bg, avatar, qr] = await Promise.all([
    loadImg(props.bgImage),
    loadImg(props.avatar),
    loadImg(props.qrCode)
  ])

  function drawCover(ctx, img, dx, dy, dWidth, dHeight) {
  const imgRatio = img.width / img.height
  const canvasRatio = dWidth / dHeight

  let sx, sy, sWidth, sHeight

  if (imgRatio > canvasRatio) {
    // 图片更宽 → 裁左右
    sHeight = img.height
    sWidth = img.height * canvasRatio
    sx = (img.width - sWidth) / 2
    sy = 0
  } else {
    // 图片更高 → 裁上下
    sWidth = img.width
    sHeight = img.width / canvasRatio
    sx = 0
    sy = (img.height - sHeight) / 2
  }

  ctx.drawImage(img, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
}

  // ===== 背景 =====
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, props.width, props.height)

  // ===== 头图 =====
//   const headerH = props.height * 0.54
  const headerH = 460
  drawCover(ctx, bg, 0, 0, props.width, headerH)

  // ===== 内容区域 =====
  const padding = 20
  let y = headerH + 40

  // 头像
  const avatarSize = 40
  ctx.save()
  ctx.beginPath()
  ctx.arc(
    padding + avatarSize / 2,
    y,
    avatarSize / 2,
    0,
    Math.PI * 2
  )
  ctx.clip()
  ctx.drawImage(avatar, padding, y - avatarSize / 2, avatarSize, avatarSize)
  ctx.restore()

  // 昵称
  ctx.fillStyle = '#333'
  ctx.font = 'bold 16px sans-serif'
  ctx.fillText(props.nickname, padding + 50, y + 5)

  // 主标题
  ctx.fillStyle = '#1f2a44'
  ctx.font = 'bold 15px sans-serif'
  wrapText(ctx, props.title, padding, y + 55, props.width - padding * 2, 30)

  y += 120

  // 副标题
  ctx.fillStyle = '#ff5a3c'
  ctx.font = 'bold 17px sans-serif'
  wrapText(ctx, `「${props.subtitle}」`, padding, y-38, props.width - padding * 2, 24)

  //标题高度
  const subtitleHeight = ctx.measureText(props.subtitle).width > props.width - padding * 2 ? 48 : 24
  y += subtitleHeight + 20

  // 描述
  ctx.fillStyle = '#666'
  ctx.font = '14px sans-serif'

  props.descList.forEach(text => {
    wrapText(ctx, text, padding, y-40, props.width - padding * 2, 22)
    y += 26
  })

  // 二维码
  const qrSize = 70
  ctx.drawImage(
    qr,
    props.width - qrSize - padding,
    y-115,
    qrSize,
    qrSize
  )
  console.log(2928)
  posterUrl.value = canvas.toDataURL('image/png')
  console.log(posterUrl.value,2929)
}

onMounted(drawPoster)
watch(() => props, drawPoster, { deep: true })
//将posterUrl的值传输给父组件
defineExpose({ posterUrl })
</script>

<style scoped>
.poster-img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}
</style>